<div class="footer-wrap">
    <div class="w-100 clearfix">
        <span class="d-block text-center text-sm-left d-sm-inline-block">©Pardna App</span>
        <!-- <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart-outline"></i></span> -->
    </div>
</div>